import { render, staticRenderFns } from "./IncomesCollapsableOrder.vue?vue&type=template&id=1dbb0186&"
import script from "./IncomesCollapsableOrder.vue?vue&type=script&lang=js&"
export * from "./IncomesCollapsableOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports